export default __webpack_public_path__ + "static/media/9fbf8d4f954a2f5f.84795546582657c8e8ac9b8554f291a1.svg";